import React from "react";
import { injectIntl } from "react-intl";
import { Link } from "react-router-dom";

import PageLayout from "components/PageLayout";
import paths from "routes/paths";

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
};

class MissingPermissionsComponent extends React.Component {
  renderContent = () => {
    const { intl } = this.props;

    return (
      <div style={styles.container}>
        <span>{intl.messages["missingPermissionsScene.description"]}</span>
        <Link to={paths.front.home}>
          {intl.messages["missingPermissionsScene.home"]}
        </Link>
      </div>
    );
  };

  render() {
    return <PageLayout hasHeader={false} content={this.renderContent()} />;
  }
}

export default injectIntl(MissingPermissionsComponent);
